import type { PlanId } from './planLimits';
import receiptScanIllustration from '@/assets/illustrations/receipt-scan.png';
import transportOrdersIllustration from '@/assets/illustrations/transport-orders.svg';
import customerPortalIllustration from '@/assets/illustrations/customer-portal.png';

export interface UpgradePromptConfig {
  headline: string;
  body: string;
  /**
   * Optional. `PlanUpgradeModal` renders the illustration block only when one is
   * set, so a prompt can ship before its artwork exists — which is the case for
   * `customer-portal` today.
   */
  illustration?: string;
  requiredPlan: PlanId;
}

export const UPGRADE_PROMPTS: Record<string, UpgradePromptConfig> = {
  'receipt-scan': {
    headline: 'Snap a receipt. Costs catch up.',
    body: "Photograph a supplier receipt and it becomes a purchase order. When a price has moved, one click updates it across every recipe and product, so when tomatoes spike you'll know which sandwiches still profit before you make them.",
    illustration: receiptScanIllustration,
    requiredPlan: 'growth',
  },
  // DECISION 70 — one prompt covers recurring orders AND the buyer's ordering
  // page, because they are one feature for pricing. It leads with TIME: the
  // recurring half is the most literal time-sale in the product, and Mike's
  // orders arrive as email today (~50/50 standing vs weekly), which is the
  // keying-in this removes.
  'customer-portal': {
    headline: 'Stop retyping the same order every week.',
    body: "Set a customer's repeating order up once and it lands in your sales orders on its own, week after week. Invite them to their own ordering page and they place and change orders themselves, instead of emailing you an order to key in.",
    illustration: customerPortalIllustration,
    requiredPlan: 'growth',
  },
  'transport-orders': {
    headline: 'Know which routes are worth your time.',
    body: 'Plan delivery routes, track driver time, and bill route costs back to each customer. See the real margin on every route — not just the products you deliver.',
    illustration: transportOrdersIllustration,
    requiredPlan: 'growth',
  },
};
